var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DOMElementEventMonitor } from "./hooks/dom-elemement-event-monitor";
import { XHRInterceptor } from "./hooks/xhr-interceptor";
import { VimeoMonitor } from "./hooks/vimeo-monitor";
import { YoutubeMonitor } from "./hooks/youtube-monitor";
import { Cookies } from "./utils/cookies";
import { Logger } from "./utils/logger";
import { XHR } from "./utils/xhr";
import { sessionCookieName, sessionServerCookieName, uidCookieName, uidServerCookieName, campaignKeyCookieName } from "./index";
import { FormSubmissionMonitor } from "./hooks/form-submission-monitor";
import { DOMUtils } from "./utils/dom";
import { dataAttributePrefix } from "./index";
import { Beacon } from "./utils/beacon";
import { DeviceUUID } from "device-uuid";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { FetchInterceptor } from "./hooks/fetch-interceptor";
export class DataTrackingClient {
    get isValidSession() {
        return this._isValidSession;
    }
    get apiHost() {
        return this._apiHost;
    }
    get domainUUID() {
        return this._domainUUID;
    }
    get userIdentity() {
        return this._userIdentity;
    }
    get arbitraryData() {
        return this._arbitraryData;
    }
    constructor(apiHost, domainUUID, userIdentity = null, arbitraryData = null) {
        this._isValidSession = false;
        this._xmlhttpOrFetchComplete = (e) => {
            //Logger.debug("xhr complete => ", e.xhr, e.item);
            Logger.info("Ajax Tracking triggered on trackingItem => " + e.item.elementId);
            Logger.verbose(e);
            if (this.isValidSession) {
                let postData = {};
                let sessionId = Cookies.getCookie(sessionCookieName);
                if (!sessionId) {
                    Logger.error("Session cookie does not exist");
                    return;
                }
                let sc = Cookies.getCookie(sessionCookieName);
                let ss = Cookies.getCookie(sessionServerCookieName);
                let uc = Cookies.getCookie(uidCookieName);
                let us = Cookies.getCookie(uidServerCookieName);
                postData["session_id"] = sessionId;
                postData["event"] = e.item.eventName;
                postData["source_url"] = window.location.href;
                postData["referrer"] = document.referrer;
                postData["domain_uuid"] = this._domainUUID;
                postData["group"] = e.item.group;
                postData["element_id"] = e.item.elementId.toString();
                postData["goal_id"] = e.item.goalId ? e.item.goalId.toString() : "0";
                postData["data-attributes"] = e.item.attributeData;
                postData["data-properties"] = e.item.propertyData;
                postData["data-cookies"] = e.item.cookieData;
                postData["user_identity"] = this._userIdentity ? this._userIdentity : "";
                postData["arbitrary_data"] = this._arbitraryData;
                postData['session_id_client'] = sc;
                postData['session_id_server'] = ss;
                postData['uid_client'] = uc;
                postData['uid_server'] = us;
                if (e.item.formConfig) {
                    let formData = {};
                    if (e.item.formConfig.dataType == "FormData") {
                        try {
                            e.xhr._data.forEach((v, k) => (formData[k] = v));
                        }
                        catch (_a) {
                            //Do nothing
                        }
                    }
                    else if (e.item.formConfig.dataType == "URLSearchParams") {
                        try {
                            let params = new URLSearchParams(e.xhr._data);
                            for (const [key, value] of params.entries()) {
                                formData[key] = value;
                            }
                        }
                        catch (_b) {
                            //Do nothing
                        }
                    }
                    else if (e.item.formConfig.dataType == "JSONString") {
                        try {
                            formData = JSON.parse(e.xhr._data);
                        }
                        catch (_c) {
                            //Do nothing
                        }
                    }
                    else if (e.item.formConfig.dataType == "Object") {
                        formData = e.xhr._data;
                    }
                    postData["data-form"] = formData;
                }
                else if (e.item.ajaxConfig) {
                    let ajaxData = {};
                    if (e.item.ajaxConfig.dataType == "FormData") {
                        try {
                            e.xhr._data.forEach((v, k) => (ajaxData[k] = v));
                        }
                        catch (_d) {
                            //Do nothing
                        }
                    }
                    else if (e.item.ajaxConfig.dataType == "URLSearchParams") {
                        try {
                            let params = new URLSearchParams(e.xhr._data);
                            for (const [key, value] of params.entries()) {
                                ajaxData[key] = value;
                            }
                        }
                        catch (_e) {
                            //Do nothing
                        }
                    }
                    else if (e.item.ajaxConfig.dataType == "JSONString") {
                        try {
                            ajaxData = JSON.parse(e.xhr._data);
                        }
                        catch (_f) {
                            //Do nothing
                        }
                    }
                    else if (e.item.ajaxConfig.dataType == "Object") {
                        ajaxData = e.xhr._data;
                    }
                    postData["data-ajax"] = {
                        url: e.xhr._requestUrl,
                        data: ajaxData,
                        method: e.xhr._requestMethod,
                        response: e.xhr.responseText
                    };
                }
                if (this.isValidSession) {
                    Beacon.send(this._apiHost + '/api/track/save-history', postData);
                    /*
                    XHR.call(this._apiHost + '/api/track/save-history', "POST", postData).then(function (res: any) {
                        Logger.debug("Element event data ata has been sent to API");
                    }, function (err: any) {
                        Logger.error("Failed to send element event data to API");
                        Logger.verbose(err);
                    });
                    */
                }
                else {
                    Logger.error("Ignoring the event as no valid session exist");
                }
            }
            else {
                Logger.error("Ignoring the event as no valid session exist");
            }
        };
        if (DataTrackingClient._instance) {
            throw new Error("Singleton class [DataTrackingClient] can't be instantiated more than once.");
        }
        this._recordPageVisitCounter = 0;
        this._domainUUID = domainUUID;
        this._trackElements = [];
        this._pageVisitGoalUrls = [];
        this._userIdentity = userIdentity;
        this._arbitraryData = arbitraryData;
        this._apiHost = apiHost;
        DataTrackingClient._instance = this;
    }
    static getInstance() {
        if (!DataTrackingClient._instance) {
            throw new Error("Core has not been initialized. Initiaze before calling getInstance()");
        }
        return DataTrackingClient._instance;
    }
    init() {
        let _self = this;
        this._pageLoadDuration = null;
        Logger.verbose("Initializing core...");
        //_self._startTracking();  return;  // ===> comment this  
        if ('performance' in window) {
            function perfObserver(list, observer) {
                const pageTiming = list.getEntriesByName(window.location)[0];
                //const pageTiming = performance.getEntriesByType("navigation")[0];
                Logger.info(pageTiming);
                if (pageTiming.duration > 0) {
                    Logger.info(`URL - ${pageTiming.name}`);
                    Logger.info(`Page Loding Duration - ${pageTiming.duration}`);
                    _self._pageLoadDuration = pageTiming.duration;
                }
                else {
                    Logger.info('pageTiming - duration - not exists');
                }
                _self.initStart();
                /*
                list.getEntries().forEach((entry) => {

                    console.log(entry);

                    if (entry.duration > 0) {
                        console.log(`URL - ${entry.name}`);
                        console.log(`Duration - ${entry.duration}`);
                    }

                });
                */
            }
            const observer = new PerformanceObserver(perfObserver);
            observer.observe({ entryTypes: ["navigation"] }); //["measure", "mark", "resource"] 
        }
        else {
            Logger.info("No Performance API ....");
        }
    }
    initStart() {
        this._loadConfigJs().then(() => {
            // domain-config.js will call datatracking.track() on each configured elements
            // Wait for a bit for the domain-config.js code to get executed and then start tracking
            setTimeout(() => {
                /* Star: Intercent XHR */
                Logger.verbose("Attaching XHR Interceptor");
                let objXHRInterceptor = XHRInterceptor.getInstance();
                objXHRInterceptor.on("complete", this._xmlhttpOrFetchComplete);
                objXHRInterceptor.init();
                /* End: Intercent XHR */
                /* Star: Intercent Fetch */
                Logger.verbose("Attaching fetch Interceptor");
                let objFetchInterceptor = FetchInterceptor.getInstance();
                objFetchInterceptor.on("complete", this._xmlhttpOrFetchComplete);
                objFetchInterceptor.init();
                /* End: Intercent Fetch */
                // Initialize the DOMElementEventInterceptor, which will listen for configured events on the tracking Elements
                let objDOMElementEventMonitor = DOMElementEventMonitor.getInstance();
                objDOMElementEventMonitor.init(this._trackElements);
                objDOMElementEventMonitor.onEvent((ev, element, elementEventData) => {
                    Logger.info(ev.type + " triggered on trackingItem => " + elementEventData.trackingItem.elementId);
                    Logger.verbose(ev);
                    Logger.verbose(element);
                    Logger.verbose(elementEventData);
                    if (this.isValidSession) {
                        let postData = {};
                        let sc = Cookies.getCookie(sessionCookieName);
                        let ss = Cookies.getCookie(sessionServerCookieName);
                        let uc = Cookies.getCookie(uidCookieName);
                        let us = Cookies.getCookie(uidServerCookieName);
                        //let sessionId: Nullable<string> = Cookies.getCookie(sessionCookieName);
                        if (!sc || !uc) { // !sessionId
                            Logger.error("Session cookie does not exist");
                            return;
                        }
                        //==================================================================================================
                        let shouldCallAjax = true;
                        let originalElementId = element.getAttribute(dataAttributePrefix + "element-id");
                        if (element.parentNode) {
                            let originalSelector = elementEventData.trackingItem.elementSelector;
                            let elementsFound = element.parentNode.querySelectorAll(originalSelector);
                            let found = false;
                            for (let i = 0; i < elementsFound.length; i++) {
                                let elementId = null;
                                if (elementsFound[i]) {
                                    elementId = elementsFound[i].getAttribute(dataAttributePrefix + "element-id");
                                    if (originalElementId == elementId) {
                                        found = true;
                                        break;
                                    }
                                }
                            }
                            if (!found) {
                                shouldCallAjax = false;
                            }
                            // document.querySelectorAll<HTMLElement>(item.elementSelector)
                        }
                        //==================================================================================================
                        //postData["session_id"] = sessionId;
                        postData["event"] = elementEventData.trackingItem.eventName;
                        postData["source_url"] = window.location.href;
                        postData["referrer"] = document.referrer;
                        postData["domain_uuid"] = this._domainUUID;
                        postData["group"] = elementEventData.trackingItem.group;
                        postData["element_id"] = elementEventData.trackingItem.elementId.toString();
                        postData["goal_id"] = elementEventData.trackingItem.goalId ? elementEventData.trackingItem.goalId.toString() : "0";
                        postData["data-attributes"] = elementEventData.attributeData;
                        postData["data-properties"] = elementEventData.propertyData;
                        postData["data-cookies"] = elementEventData.cookieData;
                        postData["user_identity"] = this._userIdentity ? this._userIdentity : "";
                        postData["arbitrary_data"] = this._arbitraryData;
                        postData['session_id_client'] = sc;
                        postData['session_id_server'] = ss;
                        postData['uid_client'] = uc;
                        postData['uid_server'] = us;
                        if (this.isValidSession) { // && shouldCallAjax
                            Beacon.send(this._apiHost + '/api/track/save-history', postData);
                            /*XHR.call(this._apiHost + '/api/track/save-history', "POST", postData).then(function (res: any) {
                                Logger.debug("Element event data ata has been sent to API");
                            }, function (err: any) {
                                Logger.error("Failed to send element event data to API");
                                Logger.verbose(err);
                            });*/
                        }
                        else {
                            if (!shouldCallAjax) {
                                Logger.verbose("Ignoring the event as the element collapse changed.");
                            }
                            else {
                                Logger.error("Ignoring the event as no valid session exist");
                            }
                        }
                    }
                    else {
                        Logger.error("Ignoring the event as no valid session exist");
                    }
                });
                FormSubmissionMonitor.getInstance().onSubmit((formSubmissionData) => {
                    Logger.debug("Form submission triggered on trackingItem => " + formSubmissionData.trackingItem.elementId);
                    Logger.verbose(formSubmissionData);
                    let postData = {};
                    let sc = Cookies.getCookie(sessionCookieName);
                    let ss = Cookies.getCookie(sessionServerCookieName);
                    let uc = Cookies.getCookie(uidCookieName);
                    let us = Cookies.getCookie(uidServerCookieName);
                    //let sessionId: Nullable<string> = Cookies.getCookie(sessionCookieName);
                    if (!sc || !uc) {
                        Logger.error("Session cookie does not exist");
                        return;
                    }
                    //postData["session_id"] = sessionId;
                    postData["event"] = formSubmissionData.trackingItem.eventName;
                    postData["source_url"] = window.location.href;
                    postData["referrer"] = document.referrer;
                    postData["domain_uuid"] = this._domainUUID;
                    postData["group"] = formSubmissionData.trackingItem.group;
                    postData["element_id"] = formSubmissionData.trackingItem.elementId.toString();
                    postData["goal_id"] = formSubmissionData.trackingItem.goalId ? formSubmissionData.trackingItem.goalId.toString() : "0";
                    postData["data-attributes"] = formSubmissionData.attributeData;
                    postData["data-properties"] = formSubmissionData.propertyData;
                    postData["data-cookies"] = formSubmissionData.cookieData;
                    postData["data-form"] = formSubmissionData.formData;
                    postData["user_identity"] = this._userIdentity ? this._userIdentity : "";
                    postData["arbitrary_data"] = this._arbitraryData;
                    postData['session_id_client'] = sc;
                    postData['session_id_server'] = ss;
                    postData['uid_client'] = uc;
                    postData['uid_server'] = us;
                    if (this.isValidSession) {
                        Beacon.send(this._apiHost + '/api/track/save-history', postData);
                        /*
                        XHR.call(this._apiHost + '/api/track/save-history', "POST", postData).then(function (res: any) {
                            Logger.debug("Form submission ata has been sent to API");
                        }, function (err: any) {
                            Logger.error("Failed to send form submission data to API");
                            Logger.verbose(err);
                        });*/
                    }
                    else {
                        Logger.error("Ignoring the event as no valid session exist");
                    }
                });
                let objVimeoMonitor = VimeoMonitor.getInstance();
                objVimeoMonitor.onPlayVideo((ev, element, elementEventData) => {
                    //Logger.info(ev.type + " triggered on trackingItem => " + elementEventData.trackingItem.elementId);
                    Logger.info('Vimeo Play Event' + " triggered on trackingItem => " + elementEventData.trackingItem.elementId);
                    Logger.verbose(ev);
                    Logger.verbose(element);
                    Logger.verbose(elementEventData);
                    if (this.isValidSession) {
                        let postData = {};
                        let sc = Cookies.getCookie(sessionCookieName);
                        let ss = Cookies.getCookie(sessionServerCookieName);
                        let uc = Cookies.getCookie(uidCookieName);
                        let us = Cookies.getCookie(uidServerCookieName);
                        //let sessionId: Nullable<string> = Cookies.getCookie(sessionCookieName);
                        if (!sc || !uc) {
                            Logger.error("Session cookie does not exist");
                            return;
                        }
                        //postData["session_id"] = sessionId;
                        postData["event"] = elementEventData.trackingItem.eventName;
                        postData["source_url"] = window.location.href;
                        postData["referrer"] = document.referrer;
                        postData["domain_uuid"] = this._domainUUID;
                        postData["group"] = elementEventData.trackingItem.group;
                        postData["element_id"] = elementEventData.trackingItem.elementId.toString();
                        postData["goal_id"] = elementEventData.trackingItem.goalId ? elementEventData.trackingItem.goalId.toString() : "0";
                        postData["data-attributes"] = elementEventData.attributeData;
                        postData["data-properties"] = elementEventData.propertyData;
                        postData["data-cookies"] = elementEventData.cookieData;
                        postData["user_identity"] = this._userIdentity ? this._userIdentity : "";
                        postData["arbitrary_data"] = this._arbitraryData;
                        postData["data-vimeo"] = elementEventData.vimeoData;
                        postData['session_id_client'] = sc;
                        postData['session_id_server'] = ss;
                        postData['uid_client'] = uc;
                        postData['uid_server'] = us;
                        // ******** Vimeo Data *****************************
                        if (this.isValidSession) {
                            Beacon.send(this._apiHost + '/api/track/save-history', postData);
                            /*
                            XHR.call(this._apiHost + '/api/track/save-history', "POST", postData).then(function (res: any) {
                                Logger.debug("Vimeo Element event data has been sent to API");
                            }, function (err: any) {
                                Logger.error("Failed to send Vimeo element event data to API");
                                Logger.verbose(err);
                            });*/
                        }
                        else {
                            Logger.error("Ignoring the Vimeo event as no valid session exist");
                        }
                    }
                    else {
                        Logger.error("Ignoring the Vimeo event as no valid session exist");
                    }
                });
                let objYoutubeMonitor = YoutubeMonitor.getInstance();
                objYoutubeMonitor.onPlayVideo((ev, element, elementEventData) => {
                    //Logger.info(ev.type + " triggered on trackingItem => " + elementEventData.trackingItem.elementId);
                    Logger.info('Youtube Play Event' + " triggered on trackingItem => " + elementEventData.trackingItem.elementId);
                    Logger.verbose(ev);
                    Logger.verbose(element);
                    Logger.verbose(elementEventData);
                    if (this.isValidSession) {
                        let postData = {};
                        let sc = Cookies.getCookie(sessionCookieName);
                        let ss = Cookies.getCookie(sessionServerCookieName);
                        let uc = Cookies.getCookie(uidCookieName);
                        let us = Cookies.getCookie(uidServerCookieName);
                        let sessionId = Cookies.getCookie(sessionCookieName);
                        if (!sc || !uc) {
                            Logger.error("Session cookie does not exist");
                            return;
                        }
                        //postData["session_id"] = sessionId;
                        postData["event"] = elementEventData.trackingItem.eventName;
                        postData["source_url"] = window.location.href;
                        postData["referrer"] = document.referrer;
                        postData["domain_uuid"] = this._domainUUID;
                        postData["group"] = elementEventData.trackingItem.group;
                        postData["element_id"] = elementEventData.trackingItem.elementId.toString();
                        postData["goal_id"] = elementEventData.trackingItem.goalId ? elementEventData.trackingItem.goalId.toString() : "0";
                        postData["data-attributes"] = elementEventData.attributeData;
                        postData["data-properties"] = elementEventData.propertyData;
                        postData["data-cookies"] = elementEventData.cookieData;
                        postData["user_identity"] = this._userIdentity ? this._userIdentity : "";
                        postData["arbitrary_data"] = this._arbitraryData;
                        postData["data-youtube"] = elementEventData.youtubeData;
                        postData['session_id_client'] = sc;
                        postData['session_id_server'] = ss;
                        postData['uid_client'] = uc;
                        postData['uid_server'] = us;
                        // ******** Youtube Data *****************************
                        if (this.isValidSession) {
                            Beacon.send(this._apiHost + '/api/track/save-history', postData);
                            /*
                            XHR.call(this._apiHost + '/api/track/save-history', "POST", postData).then(function (res: any) {
                                Logger.debug("Youtube Element event data has been sent to API");
                            }, function (err: any) {
                                Logger.error("Failed to send Youtube element event data to API");
                                Logger.verbose(err);
                            });
                            */
                        }
                        else {
                            Logger.error("Ignoring the Youtube event as no valid session exist");
                        }
                    }
                    else {
                        Logger.error("Ignoring the Youtube event as no valid session exist");
                    }
                });
                this._startTracking();
            }, 200);
        });
    }
    addItemToTrack(item) {
        this._trackElements.push(item);
    }
    getTrackingItems() {
        return this._trackElements;
    }
    getTrackingElementById(id) {
        let trackingItem = null;
        for (let i = 0; i < this._trackElements.length; i++) {
            if (this._trackElements[i].elementId == id) {
                trackingItem = this._trackElements[i];
                break;
            }
        }
        ;
        return trackingItem;
    }
    addGoalUrl(objGoalURL) {
        this._pageVisitGoalUrls.push(objGoalURL);
    }
    _loadConfigJs() {
        return new Promise((resolve, reject) => {
            Logger.verbose("Loading domain-config.js");
            var script = document.createElement('script');
            script.onload = () => {
                Logger.debug('domin-config.js js loaded!');
                resolve();
            };
            script.onerror = () => {
                Logger.error("Failed to load domin-config.js");
                reject();
            };
            let script_url = this._apiHost + '/api/track/generate/' + this._domainUUID + '/domain-config.js';
            //let script_url = this._apiHost + '/assets/track-js-source/dist/domain-config.sample.js';
            script.setAttribute('src', script_url);
            script.setAttribute('type', 'text/javascript');
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    }
    // not used any more ***************************
    /*
    private _startTracking_remove() {
        Logger.verbose("Core::startTracking() called");

        this._verifySession_remove().then((resp: any) => {
            if (resp.status) {
                this._recordPageVisit().then((response: any) => {
                    FormSubmissionMonitor.getInstance().checkFormSubmissionStatus(window.document.body.innerText);
                }, (err: any) => {
                    // Do nothing, as any bad is already handled in _recordPageVisit()
                });
            }
        }, (err) => {
            Logger.error("Failed to verify session cookie", err);
        });
    }*/
    _startTracking() {
        Logger.verbose("Core::startTracking() called");
        this._verifyUserIdentityAndSession().then((resp) => {
            Logger.verbose("============= _startTracking =================");
            Logger.verbose("_verifyUserIdentityAndSession -> Promose Resolved");
            Logger.verbose("resp ", resp);
            Logger.verbose("==============================================");
            if (resp.success) {
                this._recordPageVisit().then((response) => {
                    FormSubmissionMonitor.getInstance().checkFormSubmissionStatus(window.document.body.innerText);
                }, (err) => {
                    // Do nothing, as any bad is already handled in _recordPageVisit()
                });
            }
        }, (err) => {
            Logger.verbose("============= _startTracking =================");
            Logger.verbose("_verifyUserIdentityAndSession -> Promose Rejected");
            Logger.error("Failed to verify uid & session cookies", err);
            Logger.verbose("==============================================");
        });
    }
    _verifyUserIdentityAndSession() {
        return __awaiter(this, void 0, void 0, function* () {
            Logger.verbose("Checking if uid & session cookie exists and match ");
            let sc = Cookies.getCookie(sessionCookieName);
            let ss = Cookies.getCookie(sessionServerCookieName);
            let uc = Cookies.getCookie(uidCookieName);
            let us = Cookies.getCookie(uidServerCookieName);
            let uc2 = yield this.generateAndCheckClientUID(uc);
            let sc2 = this.generateAndCheckClientSession(sc);
            //Logger.verbose("session: ", sc);
            //Logger.verbose("uid: ", uc);
            Logger.verbose("-------------------------------------------------");
            Logger.verbose("Cookies Found => ");
            Logger.verbose({ "sc": sc, "uc": uc, "ss": ss, "us": us });
            Logger.verbose({ "sc2": sc2 });
            Logger.verbose({ "uc2": uc2 });
            Logger.verbose("-------------------------------------------------");
            if (uc2.status && sc2.status && ss && us) {
                Logger.info("Got valid Client UID & Session Cookie and Non-Empty Server UID & Session Cookie");
                let data = {
                    "uid_client": uc2.uid,
                    "session_id_client": sc2.session_id,
                    "uid_server": us,
                    "session_id_server": ss,
                    "status": "success",
                    "msg": "Tracking User & Session seems good in browser cookie",
                    "success": true,
                    "error": false
                };
                return Promise.resolve(data);
            }
            else {
                if (!sc2.status) {
                    let cookie_expiry_date = 1;
                    var expiry_date = new Date();
                    let cookie_days = (cookie_expiry_date * 24 * 60 * 60 * 1000); //(15 * 60 * 1000);
                    expiry_date.setTime(expiry_date.getTime() + cookie_days);
                    Cookies.createCookie(sessionCookieName, sc2.session_id, expiry_date);
                }
                if (!uc2.status) {
                    let cookie_expiry_date = 90;
                    let expiry_date = new Date();
                    let cookie_days = (cookie_expiry_date * 24 * 60 * 60 * 1000); //(15 * 60 * 1000);
                    expiry_date.setTime(expiry_date.getTime() + cookie_days);
                    Cookies.createCookie(uidCookieName, uc2.uid, expiry_date);
                }
                Logger.info("Generating UID & Session by calling Server API...");
                return this.verifyServerUIDAndSession(sc2.session_id, ss, uc2.uid, us);
            }
            //return Promise.resolve({ "sc" : sc, "uc" : uc });
        });
    }
    verifyServerUIDAndSession(sc, ss, uc, us
    //sessionCookieName: string,
    //domainUUID: string,
    //userIdentity: Nullable<string> = null,
    //arbitaryData: Nullable<any> = null
    ) {
        sessionCookieName;
        let domainUUID = this._domainUUID;
        let userIdentity = this._userIdentity;
        let arbitaryData = this._arbitraryData;
        let data = {};
        //let sessionId: Nullable<string> = Cookies.getCookie(sessionCookieName);
        data['referrer'] = document.referrer;
        data['current_url'] = document.location.href;
        data['domain_uuid'] = domainUUID;
        if (userIdentity)
            data['user_identity'] = userIdentity;
        if (arbitaryData)
            data['arbitrary_data'] = arbitaryData;
        //if (sessionId) data['session_id'] = sessionId;
        data['session_id_client'] = sc;
        data['session_id_server'] = ss;
        data['uid_client'] = uc;
        data['uid_server'] = us;
        let campaign_key = Cookies.getCookie(campaignKeyCookieName);
        data['campaign_key'] = campaign_key;
        Logger.verbose("verifyServerUIDAndSession - Going to call api to verify/create server uid & session.");
        return new Promise((resolve, reject) => {
            XHR.call(DataTrackingClient.getInstance().apiHost + '/api/track/verify-uid-and-session', "POST", data).then((xhr) => {
                let res;
                try {
                    res = JSON.parse(xhr.responseText);
                }
                catch (_a) {
                    Logger.error("verifyServerUIDAndSession - Response is not a valid JSON");
                    reject(new Error("Response is not a valid JSON"));
                }
                if (res.success) {
                    Logger.debug("verifyServerUIDAndSession - Server UID & Session cookie created => ");
                    Logger.debug(res.data);
                    if (res.is_new_session || res.is_new_user || res.s_referrer_campaign_changed) {
                        // do  necessary  actions....
                    }
                    var expiry_date1 = new Date();
                    let session_cookie_days = (3 * 24 * 60 * 60 * 1000); //(15 * 60 * 1000);
                    expiry_date1.setTime(expiry_date1.getTime() + session_cookie_days);
                    Cookies.createCookie(sessionServerCookieName, res.session_id_server_cookie, expiry_date1);
                    var expiry_date2 = new Date();
                    let uid_cookie_days = (180 * 24 * 60 * 60 * 1000); //(15 * 60 * 1000);
                    expiry_date2.setTime(expiry_date2.getTime() + uid_cookie_days);
                    Cookies.createCookie(uidServerCookieName, res.uid_server_cookie, expiry_date2);
                    var expiry_date3 = new Date();
                    let ref_campaign_cookie_days = (3 * 24 * 60 * 60 * 1000); //(15 * 60 * 1000);
                    expiry_date3.setTime(expiry_date3.getTime() + ref_campaign_cookie_days);
                    Cookies.createCookie(campaignKeyCookieName, res.referrer_campaign_server_cookie, expiry_date3);
                    resolve(res);
                }
                else {
                    Logger.error("verifyServerUIDAndSession - Failed to create uid & session");
                    reject(res);
                }
            }, (err) => {
                Logger.error("verifyServerUIDAndSession - Failed to create  uid & session");
                reject(err);
            });
        });
    }
    generateAndCheckClientUID(uidCookie) {
        return __awaiter(this, void 0, void 0, function* () {
            const fp = yield FingerprintJS.load();
            const fpData = yield fp.get();
            let status = false;
            if (uidCookie) {
                if (uidCookie == fpData.visitorId) {
                    status = true;
                }
            }
            return { "status": status, "uid": fpData.visitorId };
        });
    }
    generateAndCheckClientSession(sessionCookie) {
        let status = false;
        let session_id = null;
        if (sessionCookie) {
            status = true;
            session_id = sessionCookie;
        }
        else {
            status = false;
            session_id = this.generateClientSessionID();
        }
        return { "status": status, "session_id": session_id };
    }
    generateClientSessionID() {
        let session_id = '';
        let du = new DeviceUUID().parse();
        let dua = [
            du.language,
            du.platform,
            du.os,
            du.cpuCores,
            du.isAuthoritative,
            du.silkAccelerated,
            du.isKindleFire,
            du.isDesktop,
            du.isMobile,
            du.isTablet,
            du.isWindows,
            du.isLinux,
            du.isLinux64,
            du.isMac,
            du.isiPad,
            du.isiPhone,
            du.isiPod,
            du.isSmartTV,
            du.pixelDepth,
            du.isTouchScreen,
            du.browser
        ];
        let dt = new Date().getTime();
        dt = Math.floor(dt / 1000);
        let key = dua.join(':');
        key = key + ':' + dt;
        let uuid = du.hashMD5(key);
        session_id = uuid;
        return session_id;
    }
    // not used any more ***************************
    /*
    private _verifySession_remove(): Promise<any> {
        Logger.verbose("Checking if session cookie exists");
        let status = Cookies.getCookie(sessionCookieName);
        if (!status) {
            Logger.debug("Session cookie does not exist");
            return Cookies.createSessionCookie(sessionCookieName, this._domainUUID, this._userIdentity, this._arbitraryData);
        } else {
            Logger.verbose("Session cookie exist");
            //return Promise.resolve({ status: true });
            return Cookies.createSessionCookie(sessionCookieName, this._domainUUID, this._userIdentity, this._arbitraryData);
        }
    } */
    _recordPageVisit() {
        let goalId = null;
        let goalLength = this._pageVisitGoalUrls.length;
        this._recordPageVisitCounter++;
        Logger.debug('Starting recordPageVisit(). Try count => ' + this._recordPageVisitCounter.toString());
        if (this._recordPageVisitCounter <= 2) {
            for (var i = 0; i < goalLength; i++) {
                Logger.verbose(this._pageVisitGoalUrls[i]);
                let goal = this._pageVisitGoalUrls[i];
                Logger.verbose('loop if - ', document.location.href, goal.url, document.location.href.indexOf(goal.url));
                if (document.location.href.indexOf(goal.url) !== -1) {
                    goalId = goal.id;
                    break;
                }
                Logger.verbose("GoalId => ", goalId);
            }
            //let sessionId: Nullable<string> = Cookies.getCookie(sessionCookieName);
            let sc = Cookies.getCookie(sessionCookieName);
            let ss = Cookies.getCookie(sessionServerCookieName);
            let uc = Cookies.getCookie(uidCookieName);
            let us = Cookies.getCookie(uidServerCookieName);
            if (sc && uc) { // sessionId
                //let data: FormData = new FormData();
                let data = {};
                //data['session_id'] = sessionId;
                data['referrer'] = document.referrer;
                data['current_url'] = document.location.href;
                data['domain_uuid'] = this._domainUUID;
                data['page_load_duration'] = this._pageLoadDuration;
                data['page_title'] = document.title;
                data['session_id_client'] = sc;
                data['session_id_server'] = ss;
                data['uid_client'] = uc;
                data['uid_server'] = us;
                if (this._userIdentity)
                    data['user_identity'] = this._userIdentity;
                if (this._arbitraryData)
                    data['arbitrary_data'] = this._arbitraryData;
                return new Promise((resolve, reject) => {
                    XHR.call(this._apiHost + '/api/track/save-page-visit', "POST", data).then((xhr) => {
                        let res;
                        try {
                            res = JSON.parse(xhr.responseText);
                        }
                        catch (_a) {
                            Logger.error("Response is not valid JSON");
                            reject(new Error("Response is not valid JSON"));
                        }
                        // TrackPageVisit API also checks if the session id is still valid or not and responds accordingly
                        // 1 => Page Visit Stored, 2 => Session ID changed
                        if (res.status == 1) {
                            Logger.debug("Page Visit recorded");
                            this._isValidSession = true;
                            resolve(res);
                        }
                        else if (res.status == 2) {
                            Logger.error("Session ID changed. We'll retry");
                            reject(new Error("Session ID changed"));
                            //We'll remove the cookie, and then verifySession will create it again
                            //Cookies.deleteCookie(sessionCookieName);
                            Cookies.deleteCookie(sessionServerCookieName);
                            Cookies.deleteCookie(uidServerCookieName);
                            this._verifyUserIdentityAndSession().then((res) => {
                                this._recordPageVisit().then((response) => {
                                    FormSubmissionMonitor.getInstance().checkFormSubmissionStatus(window.document.body.innerText);
                                }, (err) => {
                                    //Do nothing
                                });
                            }, (err) => {
                                Logger.error("verifySession failed", err);
                            });
                        }
                    }, (err) => {
                        Logger.error("recordPageVisit failed");
                        reject(new Error("recordPageVisit failed"));
                    });
                });
            }
            else {
                Logger.error("Tracking session does not exist");
                return Promise.reject(new Error("Tracking session does not exist"));
            }
        }
        else {
            Logger.error("recordPageVisit counter exceed. Won't try further");
            return Promise.reject(new Error("recordPageVisit counter exceed. Won't try further"));
        }
    }
    prepareElementEventData(trackingItem, element) {
        let attributeData = {};
        let propertyData = {};
        let cookieData = {};
        if (trackingItem.trackingAttributes) {
            for (let j = 0; j < trackingItem.trackingAttributes.length; j++) {
                attributeData[trackingItem.trackingAttributes[j]] = element.getAttribute(trackingItem.trackingAttributes[j]);
            }
        }
        if (trackingItem.trackingProperties) {
            for (let j = 0; j < trackingItem.trackingProperties.length; j++) {
                propertyData[trackingItem.trackingProperties[j]] = DOMUtils.getProperty(element, trackingItem.trackingProperties[j]);
            }
        }
        if (trackingItem.trackingCookies) {
            for (let j = 0; j < trackingItem.trackingCookies.length; j++) {
                cookieData[trackingItem.trackingCookies[j]] = Cookies.getCookie(trackingItem.trackingCookies[j], false);
            }
        }
        let elementEventData = {
            trackingItem: trackingItem,
            attributeData: attributeData,
            propertyData: propertyData,
            cookieData: cookieData,
            vimeoData: null,
            youtubeData: null
        };
        return elementEventData;
    }
}
